import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const Banner = styled.div`
  padding: 12px 16px; margin-bottom: 12px; border-radius: 12px; background: ${({ theme }) => theme.colors.surfaceHover};
  color: ${({ theme }) => theme.colors.text}; font-size: 13px; line-height: 1.5;
`;
export default function ConnectionStatus() {
  const { t } = useTranslation();
  const [offline, setOffline] = useState(() => !navigator.onLine);
  useEffect(() => {
    const update = () => setOffline(!navigator.onLine);
    window.addEventListener('online', update); window.addEventListener('offline', update);
    return () => { window.removeEventListener('online', update); window.removeEventListener('offline', update); };
  }, []);
  return offline ? <Banner role="status">{t('ux.offlineHint')}</Banner> : null;
}
